export type UUID = string;

export interface GlobalVariable {
  id: UUID;
  service_id: string;
  key: string;
  value: string;
  type: string; // 'string' | 'number' | 'boolean' | 'object';
  created_at: string;
  updated_at: string;
}

export type GlobalVariableBaseValues = Omit<GlobalVariable, 'id' | 'service_id' | 'created_at' | 'updated_at'>;
export type GlobalVariableState = GlobalVariableBaseValues & { id: string };

export enum GlobalVariableType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  ARRAY = 'array',
  OBJECT = 'object',
}
